import en from "./en.json";
import hu from "./hu.json";

export const translations = { hu, en };
